import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetWorker, useUpdateWorker } from "@/hooks/workers";
import { CreateWorker, Worker } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(workers)/workers/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetWorker(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Worker }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateWorker({
    onSuccess: (worker) => {
      navigate({
        to: "/workers",
        params: { id: worker.id.toString() },
      });
    },
  });

  const update = async (worker: CreateWorker) => {
    await mutateAsync({ id: model.id, ...worker });
  };
  return <Form model={model} onUpsert={update} />;
}
